import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography
} from '@material-ui/core';
import { Close as CloseIcon } from '@mui/icons-material';
import AudioContent from './AudioContent';

const AudioModal = ({ open, onClose, audioPaths, auth, lessonName }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6">Audio Resource - {lessonName}</Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          style={{ position: 'absolute', right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <AudioContent audioPaths={audioPaths} auth={auth} />
      </DialogContent>
    </Dialog>
  );
};

export default AudioModal;
